var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 10.0007H4.00016V13.334H12.0002V2.66732H4.00016V6.00065H2.66683V2.00065C2.66683 1.63246 2.96531 1.33398 3.3335 1.33398H12.6668C13.035 1.33398 13.3335 1.63246 13.3335 2.00065V14.0007C13.3335 14.3689 13.035 14.6673 12.6668 14.6673H3.3335C2.96531 14.6673 2.66683 14.3689 2.66683 14.0007V10.0007ZM6.66683 7.33398V5.33398L10.0002 8.00065L6.66683 10.6673V8.66732H1.3335V7.33398H6.66683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.5763fb8305a60e12283fd66574d854a4.svg";
export { ForwardRef as ReactComponent };